export default __webpack_public_path__ + "static/the-roof-holders-6497226718674c1086906f358ea549c0.jpg";